import { useEffect } from 'react'
import { useCommandLine } from 'hooks/useCommandLine'
import { useCurrentFolderStore } from 'hooks/stores/useCurrentFolderStore'
import useNewEntrypointModal from 'hooks/useNewEntrypointModal'

export const useFolderCreateShortcut = () => {
  const { openNewEntrypointModal } = useNewEntrypointModal()
  const { addContext, removeContext } = useCommandLine()

  useEffect(() => {
    addContext('openNewEntrypointModal', openNewEntrypointModal)

    return () => removeContext('openNewEntrypointModal')
  }, [addContext, removeContext, openNewEntrypointModal])
}

export const useCurrentFolderShortcut = () => {
  const { currentFolder } = useCurrentFolderStore()
  const { addContext, removeContext } = useCommandLine()

  useEffect(() => {
    addContext('folder', currentFolder)

    return () => removeContext('openNewEntrypointModal')
  }, [addContext, removeContext, currentFolder])
}
